import React from 'react';
import * as Blocks from '../../blocks';

const BlockTypeRenderer = (props) => {
  if (!Blocks[props.BlockTypeName]) {
    throw new Error(
      `There is no blocktype with name ${props.BlockTypeName} in React app. Check exported blocks.`
    );
  }
  const RenderBlockType = Blocks[props.BlockTypeName];
  return <RenderBlockType Blocks={Blocks} {...props} />;
};

export default BlockTypeRenderer;
